/** A deputy paged from standby answers from the link in the text or email — no sign-in. */
import { useState } from 'react';
import { api } from '../shared/api.ts';
import { ErrorBox, Notice, useAction } from '../shared/ui.tsx';

export function PageReply({ token }: { token: string }) {
  const a = useAction();
  const [done, setDone] = useState<{ title: string; reply: string } | null>(null);
  const send = (reply: string) => a.run(async () => setDone(await api.post<{ title: string; reply: string }>(`/api/public/page/${token}`, { reply })));
  return (
    <div className="xfer-page">
      <header className="xfer-top">
        <img src="/bluehq-64.png" alt="" width={36} height={36} onError={(e) => ((e.target as HTMLImageElement).style.display = 'none')} />
        <div>
          <strong>Standby page</strong>
          <div className="small">Let command staff know</div>
        </div>
      </header>
      <main className="xfer-main stack">
        {done ? (
          <Notice tone={done.reply === 'coming' ? 'ok' : 'warn'}>
            {done.reply === 'coming' ? `✓ Thanks — they know you’re on your way to ${done.title}.` : `They know you can’t make it to ${done.title}.`}
          </Notice>
        ) : (
          <>
            <p>You were paged from the standby list. Are you coming?</p>
            <div className="pg-reply">
              <button className="btn primary" disabled={a.busy} onClick={() => send('coming')}>
                On my way
              </button>
              <button className="btn" disabled={a.busy} onClick={() => send('cannot')}>
                Can’t make it
              </button>
            </div>
          </>
        )}
        <ErrorBox error={a.error} />
      </main>
    </div>
  );
}
